import { useEffect, useRef } from 'react';

import type {
  DescriptionPage_CourseType as CourseType,
  DescriptionPage_DifficultyLevel as DifficultyLevel,
  DescriptionPage_ProductVariant as ProductVariant,
} from '__generated__/graphql-types';

import cookie from 'js/lib/cookie';
import useRouter from 'js/lib/useRouter';

import { AUTOCOMPLETE_PHOTO_SIZE, CourseIcon } from 'bundles/search-common/constants/autocomplete';
import { saveRecentlyViewed } from 'bundles/search-common/utils/SearchUtils';
import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import { setOrUpdateRecentlyViewedXDP } from 'bundles/unified-description-page-common/utils/setOrUpdateRecentlyViewedXDP';

export type RecentlyViewedData = {
  name?: string;
  slug?: string;
  partners?: Array<PartnerFragment> | null;
  photoUrl?: string;
  id?: string;
  difficulty?: DifficultyLevel | null;
  productType?: CourseType | ProductVariant | null;
};

function useLogRecentlyViewed({ name, slug, partners, photoUrl, id, difficulty, productType }: RecentlyViewedData) {
  const hasRunSet = useRef(false);
  const hasRunSave = useRef(false);
  const path = useRouter().location.pathname;

  useEffect(() => {
    const sessionId = cookie.get('__204u');

    if (sessionId && id && !hasRunSet.current) {
      setOrUpdateRecentlyViewedXDP(id, sessionId);
      hasRunSet.current = true;
    }
  }, [id]);

  useEffect(() => {
    if (partners && name && !hasRunSave.current) {
      saveRecentlyViewed({
        name,
        path,
        imageIconWithSize: photoUrl ? { imageUrl: photoUrl, size: AUTOCOMPLETE_PHOTO_SIZE } : CourseIcon,
        partnerName: partners && partners[0].name,
        slug,
        partnerLogo: partners && (partners[0].squareLogo || CourseIcon),
        difficulty,
        productType,
      });
      hasRunSave.current = true;
    }
  }, [difficulty, id, name, partners, path, photoUrl, productType, slug]);
}

export default useLogRecentlyViewed;
